import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import {UserService} from "../../../service/user.service";
import {Router} from "@angular/router";
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-index-enterprise',
  templateUrl: './index-enterprise.component.html',
  styleUrls: ['./index-enterprise.component.css']
})
export class IndexEnterpriseComponent implements OnInit {
    dest: any;
  note: any;
  review: any;
  showNavigationIndicators = false;

  constructor(private userService:UserService,private route:Router,private renderer2: Renderer2,
              @Inject(DOCUMENT) private _document: Document) { }
  navClass = 'nav-light';

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: false,
    pullDrag: false,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 2
      },
      900: {
        items: 3
      }
    },
    nav: false
  };
    config: any;

  customOptions2: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: false,
    pullDrag: false,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 1
      },
      900: {
        items: 1
      }
    },
    nav: false
  };
  config2: any;

  ngOnInit(): void {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v10.0';
    s.text = ``;
    this.renderer2.appendChild(this._document.body, s);


    this.getallDesti();
    this.getallNotes();
    this.getAllReviews();

    if( window.localStorage )
    {
      if( !localStorage.getItem('firstLoad') )
      {
        localStorage['firstLoad'] = true;
        window.location.reload();
      }
      else
        localStorage.removeItem('firstLoad');
    }
  }

  getallDesti(){
    this.userService.getallDesti().subscribe(
        res=>{
          this.dest=res.data;
        }
    )
  }

  booking(d: any) {
    localStorage.setItem('desti',JSON.stringify(d));
    this.route.navigate(['/destination-detail']);
  }

  getallNotes(){
    this.userService.getallNotes().subscribe(
        res=>{
          this.note=res.data;
        }
    )
  }

  getAllReviews(){
    this.userService.getallReview().subscribe(
        res=>{
          this.review = res.data;
        }
    )
  }
}
